import { motion } from 'motion/react';

interface Props {
  onClose(): void;
  onSelect(category: string): void;
}

const categories = [
  'agents',
  'crypto',
  'characters',
  'scenes',
  'film',
  'code',
  'robotics',
  'games & worlds'
];

export default function TemplatesDropdownModal({ onClose, onSelect }: Props) {
  return (
    <>
      {/* Click-away backdrop at high z-index */}
      <div 
        style={{ 
          position: 'fixed', 
          inset: 0, 
          zIndex: 2147483640, 
          background: 'rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(1px)',
        }} 
        onClick={onClose} 
      />

      {/* Popover positioned exactly beneath the header actions area */}
      <motion.div
        key="templates-dropdown-root"
        initial={{ opacity: 0, y: -8, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -8, scale: 0.96 }}
        transition={{ duration: 0.15, ease: 'easeOut' }}
        className="glass glass--strong"
        style={{
          position: 'fixed',
          top: '44px',
          right: '80px', // Perfectly maps to the Templates button on desktop
          zIndex: 2147483647,
          minWidth: '170px',
          padding: '6px',
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          gap: '3px',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.75)',
          border: '1px solid var(--accent)',
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ padding: '4px 8px 6px 8px', borderBottom: '1px solid var(--line)', marginBottom: '4px' }}>
          <span className="sc" style={{ fontSize: '9px', opacity: 0.6, letterSpacing: '0.1em' }}>Templates</span>
        </div>
        {categories.map(cat => (
          <button
            key={cat}
            className="btn btn--ghost"
            style={{
              justifyContent: 'flex-start',
              padding: '6px 10px',
              fontSize: '10px',
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
              width: '100%',
              textAlign: 'left',
              minHeight: '28px',
              borderRadius: '5px',
              transition: 'background 0.2s',
            }}
            onClick={() => {
              onSelect(cat);
              onClose();
            }}
          >
            <span style={{ marginRight: '6px', color: 'var(--accent)', fontSize: '8px' }}>✦</span>
            {cat.replace('&', '/')}
          </button>
        ))}
      </motion.div>
    </>
  );
}
